import { Location } from "@angular/common";
import { Router } from "@angular/router";

/** A dónde lleva «Regresar» si no hay de dónde se vino (se entró directo a la página). */
export const RUTA_NUEVA_SOLICITUD = "solicitudes/nueva";

/**
 * «Regresar» / «Cancelar» de las páginas de Perfil y Capacitación
 * (14/10/2026): vuelven a la página de la que se vino —«Nueva solicitud», o
 * «Solicitud de tickets» si se abrieron desde ahí— en vez de ir siempre a
 * «Solicitud de tickets». Si se entró directo a la página (es la primera
 * navegación dentro del COS), van a «Nueva solicitud».
 */
export function regresaDeSolicitud(location: Location, router: Router): void {
  const estado = location.getState() as { navigationId?: number } | null;
  if ((estado?.navigationId ?? 1) > 1) {
    location.back();
  } else {
    router.navigate([RUTA_NUEVA_SOLICITUD]);
  }
}
